import PropTypes from 'prop-types';
import { renderChildren } from '@blaze-cms/react-page-builder';
import getBlockClasses from './get-block-classes';
import { HIERARCHY, COLUMN_CLASSES } from './constants';

const HierarchyCardsBlock = ({ cardsSeparator, combined, channel, parsedChildren, withTitle }) => {
  if (parsedChildren.length < 3) return null;

  return (
    <div
      data-testid="hierarchy-wrapper"
      className={getBlockClasses(HIERARCHY, { cardsSeparator, combined, channel, withTitle })}>
      <div className={COLUMN_CLASSES}>{renderChildren(parsedChildren[0])}</div>

      <div className={COLUMN_CLASSES}>
        {renderChildren(parsedChildren[1])}

        {renderChildren(parsedChildren[2])}
      </div>
    </div>
  );
};

HierarchyCardsBlock.propTypes = {
  cardsSeparator: PropTypes.bool.isRequired,
  combined: PropTypes.bool.isRequired,
  channel: PropTypes.string,
  parsedChildren: PropTypes.array.isRequired,
  withTitle: PropTypes.bool.isRequired
};

export default HierarchyCardsBlock;
